import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import Helmet from 'react-helmet';
import { Container, Row, Col, Card, CardImgOverlay, CardHeader, CardTitle, CardBody } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import config from '../../../../config';

import { getContentBlockItemByName } from '../../../Cms/CmsActions';

import ReviewAddForm from '../../components/form/ReviewAddForm';

import Breadcrumbs from '../../../App/components/view/Breadcrumbs';
import HtmlComponent from '../../../../components/Text/HtmlComponent';
import FileLoader from '../../../../components/Content/FileLoader';


function ReviewAddPage({ page }) {
    const image = getContentBlockItemByName(page.blocks, 'image');
    const title = getContentBlockItemByName(page.blocks, 'title');
    const content = getContentBlockItemByName(page.blocks, 'content');

    return (
        <Container>
            <Card>
                {image && <FileLoader filename={image.path} loadonmount className="card-img" style={{ minHeight: '200px' }} />}
                <CardImgOverlay>
                    <Breadcrumbs crumb={page && page.title} />
                </CardImgOverlay>
            </Card>
            <div className={classnames(image && 'override-block-lg')}>
                <Row>
                    <Col xs="12" md="8">
                        {title && <h1 className="pb-3 text-dark">{title.text}</h1>}
                        {content && <HtmlComponent text={content.text} />}
                        <ReviewAddForm />
                    </Col>
                    <Col />
                </Row>
            </div>
        </Container>
    );
}

ReviewAddPage.propTypes = {
    page: PropTypes.object.isRequired,
};

export default ReviewAddPage;


export const ReviewAddPageModel = {
    type: 'page',
    name: 'reviewAdd',
    slug: 'review/add',
    blocks: [
        {
            name: 'image', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'image', // || text || link || image || mixed (with children)
        },
        {
            name: 'title', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'text', // || text || link || image || mixed (with children)
        },
        {
            name: 'content', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'html', // || text || link || image || mixed (with children)
        },
    ],
};
